import React, {useMemo} from 'react';
import Checkbox from '../../BaseComponentWrappers/MotifCheckbox';
import Tooltip from '../../BaseComponentWrappers/MotifTooltip';
import {labels} from '../../../../util/utils';

export default function DocumentLabelCellRenderer(params) {
	const rowData = params.data;
	const documentNameAndExtension = `${rowData.documentName}.${rowData.fileExt}`;

	const isDisabled = useMemo(() => {
		if (params.colDef.showToolTip && params.data.isShared) {
			return true;
		} else if (
			!params.data.isSelectedDocument &&
			(params.data?.disableAllOtherDocuments || (params.data?.disableSharedDocuments && params.data.isShared))
		) {
			return true;
		}
		return false;
	});

	const getCheckBox = () => {
		return (
			<Checkbox
				key={`doc-name-cell-${params.valueIndex}-${params.colDef.headerName}`}
				id={rowData.id}
				ellipse
				disabled={isDisabled}
				label={documentNameAndExtension}
				title={documentNameAndExtension}
				onChange={(e) => params.onChange(e, rowData)}
				checked={params.selectedDocument.find((x) => x.id === rowData?.id)}
				styleName="relateDocuments__checkbox"
			/>
		);
	};

	return (
		<>
			{params.colDef.showToolTip && params.data.isShared ? (
				<Tooltip
					className={'shareActivityDocumentTooltip'}
					variant="alt"
					allowClick={false}
					allowHover
					placement="top"
					closeButtonProps={{
						className: 'hide'
					}}
					trigger={getCheckBox()}
				>
					{labels.copyActivityHoverLabel}
				</Tooltip>
			) : (
				getCheckBox()
			)}
		</>
	);
}
